// @ts-nocheck
import React from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import StandardDetailLayout from "@/layouts/StandardDetailLayout";
import { trpcClient } from "@/lib/trpc";
import NCRForm from "./NCRForm";

export default function NCRCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const searchParams = useSearch({ strict: false }) as any;

  const sourceType = searchParams?.sourceType as
    | "IQC"
    | "IPQC"
    | "FQC"
    | undefined;
  const sourceId = searchParams?.sourceId as string | undefined;

  const { data: sourceContext, isLoading } = useQuery({
    queryKey: ["ncr-source-qc-context", sourceType, sourceId],
    queryFn: async () => {
      if (!sourceType || !sourceId) return null;
      return await (trpcClient as any).ncr.getSourceQcContext.query({
        sourceType,
        sourceId,
      });
    },
    enabled: Boolean(sourceType && sourceId),
  });

  const handleSubmit = async (data: any) => {
    try {
      const created = await (trpcClient as any).ncr.create.mutate(data);
      toast.success("Lập biên bản sự cố chất lượng (NCR 8D) thành công!");
      await queryClient.invalidateQueries({ queryKey: ["ncrs"] });
      await queryClient.invalidateQueries({ queryKey: ["ncr-all"] });
      await queryClient.invalidateQueries({ queryKey: ["ncr-stats"] });
      navigate({
        to: "/ncr/$ncrId",
        params: { ncrId: created.id },
        replace: true,
      });
    } catch (err: any) {
      toast.error(err?.message || "Lỗi khi tạo phiếu NCR");
      throw err;
    }
  };

  const mergedDefaults = {
    source: sourceType || searchParams?.source || "IPQC",
    ...(sourceContext || {}),
  };

  return (
    <StandardDetailLayout
      breadcrumbs={[
        { label: "Phiếu Không Phù Hợp (NCR)", to: "/ncr" },
        { label: "Lập phiếu NCR 8D mới" },
      ]}
      title="Lập Biên Bản NCR"
      onBack={() => navigate({ to: "/ncr" })}
      actions={
        <div className="flex items-center gap-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={() => navigate({ to: "/ncr" })}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            size="sm"
            className="bg-rose-600 hover:bg-rose-700 text-white font-bold"
            onClick={() => {
              const formEl = document.getElementById(
                "ncr-canonical-form"
              ) as HTMLFormElement | null;
              formEl?.requestSubmit();
            }}
          >
            <Save className="w-4 h-4 mr-1.5" /> Lưu Phiếu NCR 8D
          </Button>
        </div>
      }
    >
      {isLoading ? (
        <div className="flex items-center justify-center h-64">
          <Loader2 className="h-8 w-8 animate-spin text-rose-600" />
          <span className="ml-2 text-sm text-slate-500">
            Đang nạp dữ liệu chứng từ KCS gốc...
          </span>
        </div>
      ) : (
        <NCRForm
          key={`${sourceType || "manual"}-${sourceId || "new"}-${Boolean(sourceContext)}`}
          defaultValues={mergedDefaults}
          onSubmit={handleSubmit}
          onCancel={() => navigate({ to: "/ncr" })}
          submitLabel="Tạo Phiếu NCR 8D"
        />
      )}
    </StandardDetailLayout>
  );
}
